export class Link {
  constructor(d: any) {
    this.label = d.label;
    this.destination = d.destination;
    this.icon = d.icon;
    this.permissions = d.permissions || [];
    this.anyPermissions = d.anyPermissions || [];
    this.isExternal = d.isExternal;
    if (d.children) {
      d.children.forEach((element: any) => {
        const child = new Link(element);
        child.parent = d.label;
        this.children?.push(child);
      });
    }
  }
  label: string = "";
  destination: string = "";
  icon: string = "";
  permissions: string[] = [];
  anyPermissions: string[] = [];
  isPermitted: boolean = false;
  pinned: boolean = false;
  children?: Link[] = [];
  parent?: string;
  isExternal: boolean = false;
}
